import { render, staticRenderFns } from "./GoodsCoupon.vue?vue&type=template&id=3589b30c&scoped=true"
import script from "./GoodsCoupon.vue?vue&type=script&lang=js"
export * from "./GoodsCoupon.vue?vue&type=script&lang=js"
import style0 from "./GoodsCoupon.vue?vue&type=style&index=0&id=3589b30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3589b30c",
  null
  
)

export default component.exports